/**
 * Program: SKP Router
 * Author: SKP
 * Description: router setting file
 */
import Vue                                              from 'vue';
import Router                                           from 'vue-router';
import axios                                            from 'axios';
import qs                                               from 'query-string';
import moment                                           from 'moment';
import constants                                        from '@/constants';
import store                                            from '@/vuex/store';
import { SDLUtil, StringUtil, MenuUtil }   from '@/utils';
import GSPNCryptor    									from '@/utils/GSPNCryptor';
import CSPCryptor    									from '@/utils/CSPCryptor';
import { i18n, loadLanguageAsync }                      from '../i18n';

// 일반 컴포넌트
import SKPMain                                          from '~vb/main/SKPMain';
import HHPMain                                          from '~vb/anysvcmobile/HHPMain';
import DirectLogin                                      from '~vb/login/DirectLogin';
import LoginFromOtherSystem                             from '~vb/login/LoginFromOtherSystem';
import ErrorPage                                        from '~vb/common/ErrorPage';
import EmptyPage                                        from '~vb/common/EmptyPage';
import NoAuthPage                                       from '~vb/common/NoAuthPage';
import NoSessionPage                                    from '~vb/common/NoSessionPage';
import AdminMain                                        from '~va/AdminMain';
import ErpMain                                          from '~vb/eur/EurAdminMain';

/* SKP Services */
import api                                              from '@/service';

Vue.use(Router);

const fetchMenuAccess = menuUrl => {
    return SDLUtil.postForm(`/basis/common/getMyMenuAuth.skp`, { menuUrl: menuUrl });
};

// deprecated function
const checkMenuAccess = async (to, from, next) => {
    Vue.$log.info('※ Menu Access =>', to.path);
    /*try {
        return await fetchMenuAccess(to.path).then( res =>{
            next();
        }).catch(err => {
            alert('Check your role and try again.');
            next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/` });
        });

    } catch(e) {
        alert('Check your role and try again.');
        return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/` });
    }*/
    next();
}

const hhpAccessCheck = (to, from, next) => {
    if (to.path === '/basis/anysvcmobile/request/RequestCert') {
        return next();
    }
    if (to.path === '/basis/anysvcmobile/request/RequestOther') {
        return next();
    }
    if (to.path === '/basis/anysvcmobile/request/Request') {
        return next();
    }
    Vue.$log.debug(`CertMain.skp Check before routing. ${from.path} --> ${to.path}`);
    return axios
        .get(`${SDLUtil.API_URL}/basis/certificate/CertMain.skp`)
        .then(response => {
            Vue.$log.debug("CertMain.skp RESPONSE", response)
            next();
        })
        .catch(err => {
            Vue.$log.debug('CertMain.skp ERR', err);
            if (err.data.error.code === 'HHP_NO_CERTINFO') {
                localStorage.setItem('hhp_redirect', to.path);
                return next({ path: '/basis/certificate/CertLogin' });

            } else if (err.data.error.code === 'HHP_LOGIN_REQUIRED') {
                localStorage.setItem('hhp_redirect', to.path);
                return next({ path: '/basis/certificate/CertLogin' });

            } else if (err.data.error.code === 'HHP_CERT_REQUIRED') {
                localStorage.setItem('hhp_redirect', to.path);
                // next({ path: '/basis/anysvcmobile/request/RequestCert' });
                return next({ path: '/basis/certificate/CertLogin' });

            } else if (err.data.error.code === 'HHP_MONTH_LOCK') {
                localStorage.setItem('hhp_redirect', to.path);
                // next({ path: '/basis/anysvcmobile/request/RequestOther' });
                return next({ path: '/basis/certificate/CertLogin' });

            } else if (['HHP_FORBIDDEN'].includes(err.data.error.code)) {
                return next({ path: '/basis/certificate/CertWarning' });

            } else {
                Vue.$log.error('router unhandled case', err.data.error);
                // alert('router unhandled case.' + err.data.error.code);
                return next();
            }

            // next({ path: err.data.error.message });
        });
};

/* 권한 없는 사용자의 특정 게시판 접근 시 처리 */
const checkBoardAccess = (to, from, next) => {
    const queryStrings  = StringUtil.getAllUrlParams(to.fullPath);
    const boardId       = !StringUtil.isNull(queryStrings.board_id) ? queryStrings.board_id : (!StringUtil.isNull(queryStrings.boardid) ? queryStrings.boardid : "");
    //const knowledgeId   = !StringUtil.isNull(queryStrings.knowledge_id) ? queryStrings.knowledge_id : "";
    return axios.post(
            `${SDLUtil.API_URL}/basis/knowledge/chkBoardAccess.skp`,
            qs.stringify({ BOARD_ID: boardId/*, KNOWLEDGE_ID: knowledgeId*/ }),
            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        ).then(res => {
            const data = res.data;
            if(data.isAuth) {
                return next();

            } else {
                SDLUtil.alert({
                    title: 'TITLE.WARNING.TITLE',
                    msg: 'MESSAGE.AUTH.NOAUTH',
                    onOkEvt: () => {
                        return next({ name: 'Dashboard' });
                        // return next({ path: '/no_auth' });
                    }
                });
            }

        }).catch(err => {
            Vue.$log.error('※ Knowledge board access check error =>', err);
            return next({ path: '/no_auth' });
        });
};

export const router = new Router({
    mode: 'history',
    routes: [
        // GSPN Login process ( Parameter using GSPNEncryptor )
        {
            name: 'LoginFromOtherSystemForGSPN',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/gspnLogin`,
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ GSPN Login Check. to:', to.path, 'from:', from.path, 'qS:', queryStrings);
                let csYn = StringUtil.nvl(queryStrings.csyn);
                let params = {
                    // GSPNEncrypt parameter
                    sk              : queryStrings.sk,

                    // mGSPNEncrypt parameter
                    userId          : queryStrings.userid,         // 사용자ID
                    loginId         : queryStrings.loginid,        // 사용자ID
                    companyCode     : queryStrings.companycode,    // 법인코드
                    companyName     : queryStrings.companyname,    // 국가코드
                    accountNo       : queryStrings.accountno,      // Account 번호
                    userName        : queryStrings.username,       // 사용자명
                    employeeNo      : queryStrings.employeeno,     // Employee 번호
                    email           : queryStrings.email,          // email
                    phoneNo         : queryStrings.phoneno,
                    mobileNo        : queryStrings.mobileno,
                    partnerType     : queryStrings.partnertype,    // Partner Type: 01(ASC), 02(CP), 03(S-B2B)

                    // Non-encrypt plain parameter
                    csYn            : queryStrings.csyn,
                    gtiYn           : queryStrings.gtiyn,
                    topMenuType     : 1,
                    loadMenuKind    : `${constants.SYSTEM_LOAD_MENU_ALL}`,
                    loginSystem     : csYn.toUpperCase() || `${constants.LOGIN_SYS_APPROVAL_GSPN}`,

                    connectRoot     : 'GSPN',
                    language        : StringUtil.nvl(queryStrings.language,   'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'),  // 언어
                    dateFormat      : StringUtil.nvl(queryStrings.dateformat, 'MM.dd.yyyy'),                                                        // 날짜 포멧
                    timeFormat      : StringUtil.nvl(queryStrings.timeformat, 'a_hh@mm@ss'),                                                        // 시간 포멧
                    timeZone        : StringUtil.nvl(queryStrings.timezone,   'Asia/Seoul'),                                                        // 타임 존
                    listLineNo      : StringUtil.nvl(queryStrings.listlineno, '10'),                                                                // 목록 건수
                };

                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginFromGSPN.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        Vue.$log.info("GSPN Login process response =>", res);
                        store.dispatch('setLoginFromOtherSystem', res).then(isAuth => {
                            if(isAuth) {
                                return next({ name: 'Dashboard' });

                            } else {
                                Vue.$log.error('※ GSPN Login Check error', isAuth);
                                if(StringUtil.isNull(StringUtil.nvl(store.getter.getRegParams.encUserInfo))) {
                                  alert("Please submit SKP(Knowledge) IT VOC to get authority.\n If your GSPN/CSP system user status has changed to Active (Normal) \n please reconnect to the SKP system in 1 hour.");
                                  return next({ path: '/no_auth' });
                                };
                            };
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ GSPN Login Check error', err);
                        alert("Please submit SKP(Knowledge) IT VOC to get authority.\n If your GSPN/CSP system user status has changed to Active (Normal) \n please reconnect to the SKP system in 1 hour.");
                        return next({ path: '/no_auth' });
                    });
            }
        },
        // GSPN Support Login process ( Parameter using GSPNEncryptor )
        {
            name: 'LoginFromOtherSystemForGSPNSupport',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/supportLogin`,
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ GSPN Login Check. to:', to.path, 'from:',from.path, 'qS:', queryStrings);
                let csYn = StringUtil.nvl(queryStrings.csyn);
                let params = {
                    // GSPNEncrypt parameter
                    sk              : queryStrings.sk,

                    // mGSPNEncrypt parameter
                    userId          : queryStrings.userid,         // 사용자ID
                    loginId         : queryStrings.loginid,        // 사용자ID
                    companyCode     : queryStrings.companycode,    // 법인코드
                    companyName     : queryStrings.companyname,    // 국가코드
                    accountNo       : queryStrings.accountno,      // Account 번호
                    userName        : queryStrings.username,       // 사용자명
                    employeeNo      : queryStrings.employeeno,     // Employee 번호
                    email           : queryStrings.email,          // email
                    phoneNo         : queryStrings.phoneno,
                    mobileNo        : queryStrings.mobileno,
                    partnerType     : queryStrings.partnertype,    // Partner Type: 01(ASC), 02(CP), 03(S-B2B)

                    // Non-encrypt plain parameter
                    csYn            : queryStrings.csyn,
                    gtiYn           : queryStrings.gtiyn,
                    topMenuType     : 1,
                    loadMenuKind    : `${constants.SYSTEM_LOAD_MENU_SUP}`,
                    loginSystem     : csYn.toUpperCase() || `${constants.LOGIN_SYS_APPROVAL_GSPN}`,

                    connectRoot     : 'GSPN',
                    language        : StringUtil.nvl(queryStrings.language,   'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'),  // 언어
                    dateFormat      : StringUtil.nvl(queryStrings.dateformat, 'MM.dd.yyyy'),                                                        // 날짜 포멧
                    timeFormat      : StringUtil.nvl(queryStrings.timeformat, 'a_hh@mm@ss'),                                                        // 시간 포멧
                    timeZone        : StringUtil.nvl(queryStrings.timezone,   'Asia/Seoul'),                                                        // 타임 존
                    listLineNo      : StringUtil.nvl(queryStrings.listlineno, '10'),                                                                // 목록 건수
                };

                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginFromGSPN.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        Vue.$log.info("GSPN Login process response =>", res);
                        store.dispatch('setLoginFromOtherSystem', res).then(isAuth => {
                            if(isAuth) {
                                return next(MenuUtil.getSupportMain());

                            } else {
                                Vue.$log.error('※ GSPN Login Check error', isAuth);
                                if(StringUtil.isNull(StringUtil.nvl(store.getter.getRegParams.encUserInfo))) {
                                    alert("No register login user. This system is not available.");
                                    return next({ path: '/no_auth' });
                                };
                            };
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ GSPN Login Check error', err);
                        alert("No register login user. This system is not available.");
                        return next({ path: '/no_auth' });
                    });
            }
        },
        // GSPN Erp Approval Login process ( Parameter using GSPNEncryptor )
        {
            name: 'LoginFromOtherSystemForGSPNErpApproval',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/gspnERPLogin`,
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ GSPN Login Check. to:', to.path, 'from:', from.path, 'qS:', queryStrings);
                let csYn = StringUtil.nvl(queryStrings.csyn);
                let params = {
                    // GSPNEncrypt parameter
                    sk              : queryStrings.sk,

                    // mGSPNEncrypt parameter
                    userId          : queryStrings.userid,         // 사용자ID
                    loginId         : queryStrings.loginid,        // 사용자ID
                    companyCode     : queryStrings.companycode,    // 법인코드
                    companyName     : queryStrings.companyname,    // 국가코드
                    accountNo       : queryStrings.accountno,      // Account 번호
                    userName        : queryStrings.username,       // 사용자명
                    employeeNo      : queryStrings.employeeno,     // Employee 번호
                    email           : queryStrings.email,          // email
                    phoneNo         : queryStrings.phoneno,
                    mobileNo        : queryStrings.mobileno,
                    partnerType     : queryStrings.partnertype,    // Partner Type: 01(ASC), 02(CP), 03(S-B2B)

                    // Non-encrypt plain parameter
                    csYn            : queryStrings.csyn,
                    gtiYn           : queryStrings.gtiyn,
                    topMenuType     : 1,
                    loadMenuKind    : `${constants.SYSTEM_LOAD_MENU_ALL}`,
                    loginSystem     : csYn.toUpperCase() || `${constants.LOGIN_SYS_APPROVAL_GSPN}`,

                    connectRoot     : 'GSPN',
                    language        : StringUtil.nvl(queryStrings.language,   'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'),  // 언어
                    dateFormat      : StringUtil.nvl(queryStrings.dateformat, 'MM.dd.yyyy'),                                                        // 날짜 포멧
                    timeFormat      : StringUtil.nvl(queryStrings.timeformat, 'a_hh@mm@ss'),                                                        // 시간 포멧
                    timeZone        : StringUtil.nvl(queryStrings.timezone,   'Asia/Seoul'),                                                        // 타임 존
                    listLineNo      : StringUtil.nvl(queryStrings.listlineno, '10'),                                                                // 목록 건수
                };

                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginFromGSPN.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        Vue.$log.info("GSPN Login process response =>", res);
                        store.dispatch('setLoginFromOtherSystem', res).then(isAuth => {
                            if(isAuth) {
                                return next({ name: 'requestManagerList' });

                            } else {
                                Vue.$log.error('※ GSPN Login Check error', isAuth);
                                if(StringUtil.isNull(StringUtil.nvl(store.getter.getRegParams.encUserInfo))) {
                                    alert("No register login user. This system is not available.");
                                    return next({ path: '/no_auth' });
                                };
                            };
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ GSPN Login Check error', err);
                        alert("No register login user. This system is not available.");
                        return next({ path: '/no_auth' });
                    });
            }
        },
        // CSP Login process ( Parameter using CSPEncryptor )
        {
            name: 'LoginFromOtherSystemForCSP',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/cspLogin`,
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ CSP Login Check. to:', to.path, 'from:', from.path, 'qS:', queryStrings);
                let csYn = StringUtil.nvl(queryStrings.csyn);
                let params = {
                    // CSPEncrypt parameter
                    sk              : queryStrings.sk,

                    // mGSPNEncrypt parameter
                    userId          : queryStrings.userid,         // 사용자ID
                    loginId         : queryStrings.loginid,        // 사용자ID
                    companyCode     : queryStrings.companycode,    // 법인코드
                    companyName     : queryStrings.companyname,    // 국가코드
                    accountNo       : queryStrings.accountno,      // Account 번호
                    userName        : queryStrings.username,       // 사용자명
                    employeeNo      : queryStrings.employeeno,     // Employee 번호
                    email           : queryStrings.email,          // email
                    phoneNo         : queryStrings.phoneno,
                    mobileNo        : queryStrings.mobileno,
                    partnerType     : queryStrings.partnertype,    // Partner Type: 01(ASC), 02(CP), 03(S-B2B)

                    // Non-encrypt plain parameter
                    csYn            : queryStrings.csyn,
                    gtiYn           : queryStrings.gtiyn,
                    topMenuType     : 1,
                    loadMenuKind    : `${constants.SYSTEM_LOAD_MENU_ALL}`,
                    loginSystem     : csYn.toUpperCase() || `${constants.LOGIN_SYS_APPROVAL_GSPN}`,

                    connectRoot     : 'GSPN',  // 모르는 값으로 유지하자 
                    language        : StringUtil.nvl(queryStrings.language,   'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'),  // 언어
                    dateFormat      : StringUtil.nvl(queryStrings.dateformat, 'MM.dd.yyyy'),                                                        // 날짜 포멧
                    timeFormat      : StringUtil.nvl(queryStrings.timeformat, 'a_hh@mm@ss'),                                                        // 시간 포멧
                    timeZone        : StringUtil.nvl(queryStrings.timezone,   'Asia/Seoul'),                                                        // 타임 존
                    listLineNo      : StringUtil.nvl(queryStrings.listlineno, '10'),                                                                // 목록 건수
                };

                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginFromCSP.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        Vue.$log.info("CSP Login process response =>", res);
                        store.dispatch('setLoginFromOtherSystemCSP', res).then(isAuth => {
                            if(isAuth) {
                                return next({ name: 'Dashboard' });

                            } else {
                                Vue.$log.error('※ CSP Login Check error', isAuth);
                                if(StringUtil.isNull(StringUtil.nvl(store.getter.getRegParams.encUserInfo))) {
                                  alert("Please submit SKP(Knowledge) IT VOC to get authority.\n If your GSPN/CSP system user status has changed to Active (Normal) \n please reconnect to the SKP system in 1 hour.");
                                  return next({ path: '/no_auth' });
                                };
                            };
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ CSP Login Check error', err);
                        alert("Please submit SKP(Knowledge) IT VOC to get authority.\n If your GSPN/CSP system user status has changed to Active (Normal) \n please reconnect to the SKP system in 1 hour.");
                        return next({ path: '/no_auth' });
                    });
            }
        },
        // CSP Support Login process ( Parameter using CSPEncryptor )
        {
            name: 'LoginFromOtherSystemForCSPSupport',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/cspSupportLogin`,
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ CSP Login Check. to:', to.path, 'from:',from.path, 'qS:', queryStrings);
                let csYn = StringUtil.nvl(queryStrings.csyn);
                let params = {
                    // CSPEncrypt parameter
                    sk              : queryStrings.sk,

                    // mGSPNEncrypt parameter
                    userId          : queryStrings.userid,         // 사용자ID
                    loginId         : queryStrings.loginid,        // 사용자ID
                    companyCode     : queryStrings.companycode,    // 법인코드
                    companyName     : queryStrings.companyname,    // 국가코드
                    accountNo       : queryStrings.accountno,      // Account 번호
                    userName        : queryStrings.username,       // 사용자명
                    employeeNo      : queryStrings.employeeno,     // Employee 번호
                    email           : queryStrings.email,          // email
                    phoneNo         : queryStrings.phoneno,
                    mobileNo        : queryStrings.mobileno,
                    partnerType     : queryStrings.partnertype,    // Partner Type: 01(ASC), 02(CP), 03(S-B2B)

                    // Non-encrypt plain parameter
                    csYn            : queryStrings.csyn,
                    gtiYn           : queryStrings.gtiyn,
                    topMenuType     : 1,
                    loadMenuKind    : `${constants.SYSTEM_LOAD_MENU_SUP}`,
                    loginSystem     : csYn.toUpperCase() || `${constants.LOGIN_SYS_APPROVAL_GSPN}`,

                    connectRoot     : 'GSPN',
                    language        : StringUtil.nvl(queryStrings.language,   'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'),  // 언어
                    dateFormat      : StringUtil.nvl(queryStrings.dateformat, 'MM.dd.yyyy'),                                                        // 날짜 포멧
                    timeFormat      : StringUtil.nvl(queryStrings.timeformat, 'a_hh@mm@ss'),                                                        // 시간 포멧
                    timeZone        : StringUtil.nvl(queryStrings.timezone,   'Asia/Seoul'),                                                        // 타임 존
                    listLineNo      : StringUtil.nvl(queryStrings.listlineno, '10'),                                                                // 목록 건수
                };

                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginFromCSP.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        Vue.$log.info("CSP Login process response =>", res);
                        store.dispatch('setLoginFromOtherSystemCSP', res).then(isAuth => {
                            if(isAuth) {
                                return next(MenuUtil.getSupportMain());

                            } else {
                                Vue.$log.error('※ CSP Login Check error', isAuth);
                                if(StringUtil.isNull(StringUtil.nvl(store.getter.getRegParams.encUserInfo))) {
                                    alert("No register login user. This system is not available.");
                                    return next({ path: '/no_auth' });
                                };
                            };
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ CSP Login Check error', err);
                        alert("No register login user. This system is not available.");
                        return next({ path: '/no_auth' });
                    });
            }
        },
        // CSP Erp Approval Login process ( Parameter using CSPEncryptor )
        {
            name: 'LoginFromOtherSystemForCSPErpApproval',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/cspERPLogin`,
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ CSP Login Check. to:', to.path, 'from:', from.path, 'qS:', queryStrings);
                let csYn = StringUtil.nvl(queryStrings.csyn);
                let params = {
                    // CSPEncrypt parameter
                    sk              : queryStrings.sk,

                    // mGSPNEncrypt parameter
                    userId          : queryStrings.userid,         // 사용자ID
                    loginId         : queryStrings.loginid,        // 사용자ID
                    companyCode     : queryStrings.companycode,    // 법인코드
                    companyName     : queryStrings.companyname,    // 국가코드
                    accountNo       : queryStrings.accountno,      // Account 번호
                    userName        : queryStrings.username,       // 사용자명
                    employeeNo      : queryStrings.employeeno,     // Employee 번호
                    email           : queryStrings.email,          // email
                    phoneNo         : queryStrings.phoneno,
                    mobileNo        : queryStrings.mobileno,
                    partnerType     : queryStrings.partnertype,    // Partner Type: 01(ASC), 02(CP), 03(S-B2B)

                    // Non-encrypt plain parameter
                    csYn            : queryStrings.csyn,
                    gtiYn           : queryStrings.gtiyn,
                    topMenuType     : 1,
                    loadMenuKind    : `${constants.SYSTEM_LOAD_MENU_ALL}`,
                    loginSystem     : csYn.toUpperCase() || `${constants.LOGIN_SYS_APPROVAL_GSPN}`,

                    connectRoot     : 'GSPN',
                    language        : StringUtil.nvl(queryStrings.language,   'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'),  // 언어
                    dateFormat      : StringUtil.nvl(queryStrings.dateformat, 'MM.dd.yyyy'),                                                        // 날짜 포멧
                    timeFormat      : StringUtil.nvl(queryStrings.timeformat, 'a_hh@mm@ss'),                                                        // 시간 포멧
                    timeZone        : StringUtil.nvl(queryStrings.timezone,   'Asia/Seoul'),                                                        // 타임 존
                    listLineNo      : StringUtil.nvl(queryStrings.listlineno, '10'),                                                                // 목록 건수
                };

                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginFromCSP.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        Vue.$log.info("CSP Login process response =>", res);
                        store.dispatch('setLoginFromOtherSystemCSP', res).then(isAuth => {
                            if(isAuth) {
                                return next({ name: 'requestManagerList' });

                            } else {
                                Vue.$log.error('※ CSP Login Check error', isAuth);
                                if(StringUtil.isNull(StringUtil.nvl(store.getter.getRegParams.encUserInfo))) {
                                    alert("No register login user. This system is not available.");
                                    return next({ path: '/no_auth' });
                                };
                            };
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ CSP Login Check error', err);
                        alert("No register login user. This system is not available.");
                        return next({ path: '/no_auth' });
                    });
            }
        },
        // MGSPN Login process ( Parameter using GSPNEncryptor )
        {
            name: 'LoginFromOtherSystemForMGSPN',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/mgspnLogin`,
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ MGSPN Login Check. to:', to.path, 'from:', from.path, 'qS:', queryStrings);
                let csYn = StringUtil.nvl(queryStrings.csyn);
                let params = {
                    // GSPNEncrypt parameter
                    //sk              : queryStrings.sk,

                    // mGSPNEncrypt parameter
                    userId          : queryStrings.userid,         // 사용자ID
                    loginId         : queryStrings.loginid,        // 사용자ID
                    companyCode     : queryStrings.companycode,    // 법인코드
                    companyName     : queryStrings.companyname,    // 국가코드
                    accountNo       : queryStrings.accountno,      // Account 번호
                    userName        : queryStrings.username,       // 사용자명
                    employeeNo      : queryStrings.employeeno,     // Employee 번호
                    email           : queryStrings.email,          // email
                    phoneNo         : queryStrings.phoneno,
                    mobileNo        : queryStrings.mobileno,
                    partnerType     : queryStrings.partnertype,    // Partner Type: 01(ASC), 02(CP), 03(S-B2B)

                    // Non-encrypt plain parameter
                    csYn            : queryStrings.csyn,
                    gtiYn           : queryStrings.gtiyn,
                    topMenuType     : 1,
                    loadMenuKind    : `${constants.SYSTEM_LOAD_MENU_ALL}`,
                    loginSystem     : csYn.toUpperCase() || `${constants.LOGIN_SYS_APPROVAL_GSPN}`,

                    connectRoot     : 'MGSPN',
                    language        : StringUtil.nvl(queryStrings.language,   'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'),  // 언어
                    dateFormat      : StringUtil.nvl(queryStrings.dateformat, 'MM.dd.yyyy'),                                                        // 날짜 포멧
                    timeFormat      : StringUtil.nvl(queryStrings.timeformat, 'a_hh@mm@ss'),                                                        // 시간 포멧
                    timeZone        : StringUtil.nvl(queryStrings.timezone,   'Asia/Seoul'),                                                        // 타임 존
                    listLineNo      : StringUtil.nvl(queryStrings.listlineno, '10'),                                                                // 목록 건수
                };

                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginFromMGSPN.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        Vue.$log.info("MGSPN Login process response =>", res);
                        store.dispatch('setLoginFromOtherSystem', res).then(isAuth => {
                            if(isAuth) {
                                return next({ name: 'Dashboard' });

                            } else {
                                Vue.$log.error('※ MGSPN Login Check error', isAuth);
                                if(StringUtil.isNull(StringUtil.nvl(store.getter.getRegParams.encUserInfo))) {
                                    alert("No register login user. This system is not available.");
                                    return next({ path: '/no_auth' });
                                };
                            };
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ MGSPN Login Check error', err);
                        alert("No register login user. This system is not available.");
                        return next({ path: '/no_auth' });
                    });
            }
        },
        // MGSPN Support Login process ( Parameter using GSPNEncryptor )
        {
            name: 'LoginFromOtherSystemForMGSPNSupport',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/msupportLogin`,
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ MGSPN Login Check. to:', to.path, 'from:',from.path, 'qS:', queryStrings);
                let csYn = StringUtil.nvl(queryStrings.csyn);
                let params = {
                    // GSPNEncrypt parameter
                    //sk              : queryStrings.sk,

                    // mGSPNEncrypt parameter
                    userId          : queryStrings.userid,         // 사용자ID
                    loginId         : queryStrings.loginid,        // 사용자ID
                    companyCode     : queryStrings.companycode,    // 법인코드
                    companyName     : queryStrings.companyname,    // 국가코드
                    accountNo       : queryStrings.accountno,      // Account 번호
                    userName        : queryStrings.username,       // 사용자명
                    employeeNo      : queryStrings.employeeno,     // Employee 번호
                    email           : queryStrings.email,          // email
                    phoneNo         : queryStrings.phoneno,
                    mobileNo        : queryStrings.mobileno,
                    partnerType     : queryStrings.partnertype,    // Partner Type: 01(ASC), 02(CP), 03(S-B2B)

                    // Non-encrypt plain parameter
                    csYn            : queryStrings.csyn,
                    gtiYn           : queryStrings.gtiyn,
                    topMenuType     : 1,
                    loadMenuKind    : `${constants.SYSTEM_LOAD_MENU_SUP}`,
                    loginSystem     : csYn.toUpperCase() || `${constants.LOGIN_SYS_APPROVAL_GSPN}`,

                    connectRoot     : 'MGSPN',
                    language        : StringUtil.nvl(queryStrings.language,   'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'),  // 언어
                    dateFormat      : StringUtil.nvl(queryStrings.dateformat, 'MM.dd.yyyy'),                                                        // 날짜 포멧
                    timeFormat      : StringUtil.nvl(queryStrings.timeformat, 'a_hh@mm@ss'),                                                        // 시간 포멧
                    timeZone        : StringUtil.nvl(queryStrings.timezone,   'Asia/Seoul'),                                                        // 타임 존
                    listLineNo      : StringUtil.nvl(queryStrings.listlineno, '10'),                                                                // 목록 건수
                };

                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginFromMGSPN.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        Vue.$log.info("MGSPN Login process response =>", res);
                        store.dispatch('setLoginFromOtherSystem', res).then(isAuth => {
                            if(isAuth) {
                                return next(MenuUtil.getSupportMain());

                            } else {
                                Vue.$log.error('※ MGSPN Login Check error', isAuth);
                                if(StringUtil.isNull(StringUtil.nvl(store.getter.getRegParams.encUserInfo))) {
                                    alert("No register login user. This system is not available.");
                                    return next({ path: '/no_auth' });
                                };
                            };
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ MGSPN Login Check error', err);
                        alert("No register login user. This system is not available.");
                        return next({ path: '/no_auth' });
                    });
            }
        },
        // SCMS Direct login process
        {
            name: 'LoginFromOtherSystemForSCMSKnowledge',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/scmsKnowledgeLogin`,
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Object.assign(queryStrings, { directYn: 'Y', supportYn: 'N' });
                return next({ name: 'LoginFromOtherSystemForSCMS', query: queryStrings });
            }
        },
        {
            name: 'LoginFromOtherSystemForSCMSSupport',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/scmsSupportLogin`,
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Object.assign(queryStrings, { directYn: 'Y', supportYn: 'Y' });
                return next({ name: 'LoginFromOtherSystemForSCMS', query: queryStrings });
            }
        },
        // SCMS Login process ( Parameter using GSPNEncryptor )
        {
            name: 'LoginFromOtherSystemForSCMS',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/scmsLogin`,
//            beforeEnter: (to, from, next) => {
            beforeEnter: async (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);

                // SCMS 좌측 메뉴에서 직접 접근하였는지 확인
                const directYn  = queryStrings.directyn || 'N',
                      supportYn = queryStrings.supportyn || 'N';

                const isDirect  = StringUtil.strToBool(directYn),
                      isSupport = StringUtil.strToBool(supportYn);

                // SCMS 좌측 메뉴에서 직접 접근하였을 때 메뉴 권한 처리
                const scmsLoadMenuKind  = (isDirect && isSupport) ? `${constants.SYSTEM_LOAD_MENU_SUP}` : `${constants.SYSTEM_LOAD_MENU_ALL}`;
                const scmsLoginSystem   = (isDirect && isSupport) ? `${constants.LOGIN_SYS_SUPPORT}` : `${constants.LOGIN_SYS_APPROVAL_CS}`;

                // 삼성 임직원이 아닌 경우 'CMS_' 접두어를 붙여 유일한 ID 를 생성한다.
                const samsungYn = await GSPNCryptor.decrypt(queryStrings.samsungyn);
                if(samsungYn === 'N') {
                    let userId = await GSPNCryptor.decrypt(queryStrings.loginid);
                    queryStrings.loginid = await GSPNCryptor.encrypt('CMS_' + userId);
                    Vue.$log.info('※ SCMS' + (isDirect ? ' Contents ' : '') + 'Login Check. non-samsung employee. Create new unique id ->', 'CMS_' + userId);
                };

                Vue.$log.info('※ SCMS' + (isDirect ? ' Contents ' : '') + 'Login Check. to:', to.path, 'from:',from.path, 'qS:', queryStrings,
                                'loadMenu:', scmsLoadMenuKind, 'loginSystem:', scmsLoginSystem);
                let params = {
                    userId       : queryStrings.loginid,
                    companyCode  : '',
                    accountNo    : '',
                    userName     : queryStrings.loginnm,
                    employeeNo   : '',
                    employeeNn   : queryStrings.samsungyn,
                    email        : queryStrings.email,
                    phoneNo      : queryStrings.phoneno,
                    mobileNo     : queryStrings.mobileno,
                    partnerType  : '',
                    language     : 'en',
                    dateFormat   : 'MM.dd.yyyy',
                    timeFormat   : 'a_hh@mm@ss',
                    timeZone     : 'Asia/Seoul',
                    listLineNo   : 10,
                    topMenuType  : 1,
                    loadMenuKind : scmsLoadMenuKind,
                    loginSystem  : scmsLoginSystem,
                    connectRoot  : isDirect ? 'SCMS-D' : 'SCMS',
                    // 추가 파라미터
                    cttType      : queryStrings.ctttype,        // SB, RT
                    modelCd      : queryStrings.modelcd,        // SCMS에서 팝업 호출시, todo목록에서 선택한 모델코드. manual일경우는 빈값
                    ecnNo        : queryStrings.ecnno,          // SCMS에서 팝업 호출시, sb일경우 넘어오는 ecnNo값. RT일경우는 빈값
                    knowledgeId  : queryStrings.knowledgeid,    // SCMS에서 수정 팝업 호출 시, KnowledgeId 는 필수
                    cdprodtype   : queryStrings.cdprodtype,     // SCMS에서 넘어온 카테고리2
                    cdprodsubtype: queryStrings.cdprodsubtype,  // SCMS에서 넘어온 카테고리3
                    skpt         : queryStrings.skpt
                };

                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginFromSCMS.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        store.dispatch('setLoginFromOtherSystem', res).then(isAuth => {
                            if(isAuth) {
                                // SCMS 직접 접근인 경우
                                if(isDirect) {
                                    if (scmsLoadMenuKind === `${constants.SYSTEM_LOAD_MENU_SUP}`) {
                                        return next(MenuUtil.getSupportMain());

                                    } else {
                                        return next({ name: 'Dashboard' });
                                    }

                                } else {
                                    const popupParams = store.getters.getPopupParams || {};
                                    let knowledgeId = StringUtil.nvl(popupParams.knowledgeId);
                                    let isModify = StringUtil.isNull(knowledgeId) ? false : true;

                                    let queryParams = {
                                        cttType: StringUtil.nvl(popupParams.cttType),
                                        scmsModelCd: StringUtil.nvl(popupParams.scmsModelCd),
                                        scmsModelGbmCd: StringUtil.nvl(popupParams.scmsModelGbmCd),
                                        scmsEcnNo: StringUtil.nvl(popupParams.scmsEcnNo),
                                        boardType1: StringUtil.nvl(popupParams.boardType1),
                                        boardType2: StringUtil.nvl(popupParams.boardType2),
                                        scmsCategoryCd1: StringUtil.nvl(popupParams.categoryCd1),
                                        scmsCategoryCd2: StringUtil.nvl(popupParams.categoryCd2),
                                        scmsCategoryCd3: StringUtil.nvl(popupParams.categoryCd3),
                                        knowledgeId: knowledgeId,
                                        isModify: isModify,
                                        isSCMSDirect: true,
                                        skpt: StringUtil.nvl(popupParams.skpt)
                                    };

                                    return next({ name: 'RegisterForm', query: queryParams });
                                }

                            } else {
                                Vue.$log.error('※ SCMS' + (isDirect ? ' Contents ' : '') + 'Login Check error', isAuth);
                                alert("No register login user. This system is not available.");
                                next({ path: '/no_auth' }); // 추후 수정
                            }
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ SCMS' + (isDirect ? ' Contents ' : '') + 'Login Check error', err);
                        alert("No register login user. This system is not available.");
                        next({ path: '/no_auth' }); // 추후 수정
                    });
            },
        },
        // Login
        {
            name: 'Login',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/Sensp560`,
            component: DirectLogin,
            beforeEnter: (to, from, next) => {
                let connSystem = store.getters.getConnSystem || '';
                if(!StringUtil.isNull(connSystem) && connSystem === 'SCMS') {
                    let popupParams = store.getters.getPopupParams || {};
                    if(StringUtil.isNull(popupParams)) {
                        Vue.$log.info('※ SCMS Register form Access not allowed.');
                        return next({ path: '/no_auth' });

                    } else {
                        let knowledgeId = StringUtil.nvl(popupParams.knowledgeId);
                        let isModify = StringUtil.isNull(knowledgeId) ? false : true;

                        let params = {
                            cttType: StringUtil.nvl(popupParams.cttType),
                            scmsModelCd: StringUtil.nvl(popupParams.scmsModelCd),
                            scmsModelGbmCd: StringUtil.nvl(popupParams.scmsModelGbmCd),
                            scmsEcnNo: StringUtil.nvl(popupParams.scmsEcnNo),
                            boardType1: StringUtil.nvl(popupParams.boardType1),
                            boardType2: StringUtil.nvl(popupParams.boardType2),
                            knowledgeId: knowledgeId,
                            isModify: isModify,
                            isSCMSDirect: true
                        };

                        Vue.$log.info('※ SCMS Register redirect ->', params);
                        return next({ name: 'RegisterForm', query: params });
                    }

                } else {
                    return next();
                }
            },
        },
        // Logout
        {
            name: 'logout',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/logout`,
            component: () => import(/* webpackChunkName: '[request]' */ '~vb/login/Logout')
        },
        // 연계 시스템 사용자 등록 페이지
        {
            name: 'RegisterAccess',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/registerAccess`,
//            beforeEnter: (to, from, next) => {
            beforeEnter: async (to, from, next) => {
                const qs = StringUtil.getAllUrlParams(to.fullPath);
                const regParams = store.getters.getRegParams || {};
                Vue.$log.info('※ RegisterAccess check / to:', to.path, 'from:',from.path, 'qS:', qs, 'regParams:', regParams);
                try {
                    const encObj = regParams.encUserInfo || {};
//                    const userInfo = JSON.parse(GSPNCryptor.decrypt(encObj));
                    const userInfoJsonStr = await GSPNCryptor.decrypt(encObj); 
                    const userInfo = JSON.parse(userInfoJsonStr);
                    Object.assign(userInfo, { isRegister: true });
                    Vue.$log.info('※ RegisterAccess GSPNCryptor decoding =>', userInfo);

                    store.commit('REG_PARAMS', userInfo);
                    return next({ name: 'RequestForAuth' });

                } catch(e) {
                    Vue.$log.warn('※ User Register form Access not allowed.', e);
                    return next({ name: 'NoAuth' });
                }
            }
        },
        {
            name: 'RequestForAuth',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/requestForAuth`,
            component: () => import(/* webpackChunkName: '[login]' */ '~vb/login/RequestForAuth'),
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                const regParams = store.getters.getRegParams || { isRegister: false };
                if(!regParams.isRegister) {
                    store.commit('REG_PARAMS', {});
                    Vue.$log.warn('※ User Register form Access not allowed.');
                    return next({ name: 'NoAuth' });

                } else {
                    Vue.$log.info('※ RequestForAuth check / to:', to.path, 'from:',from.path, 'qS:', queryStrings);
                    return next();
                }
            }
        },
        // 연계 시스템 사용자 등록 페이지
        {
            name: 'RegisterAccessCSP',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/registerAccessCSP`,
//            beforeEnter: (to, from, next) => {
            beforeEnter: async (to, from, next) => {
                const qs = StringUtil.getAllUrlParams(to.fullPath);
                const regParams = store.getters.getRegParams || {};
                Vue.$log.info('※ RegisterAccess check / to:', to.path, 'from:',from.path, 'qS:', qs, 'regParams:', regParams);
                try {
                    const encObj = regParams.encUserInfo || {};
//                    const userInfo = JSON.parse(GSPNCryptor.decrypt(encObj));
                    const userInfoJsonStr = await CSPCryptor.decrypt(encObj); 
                    const userInfo = JSON.parse(userInfoJsonStr);
                    Object.assign(userInfo, { isRegister: true });
                    Vue.$log.info('※ RegisterAccess CSPCryptor decoding =>', userInfo);

                    store.commit('REG_PARAMS', userInfo);
                    return next({ name: 'RequestForAuthCSP' });

                } catch(e) {
                    Vue.$log.warn('※ User Register form Access not allowed.', e);
                    return next({ name: 'NoAuth' });
                }
            }
        },
        {
            name: 'RequestForAuthCSP',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/requestForAuthCSP`,
            component: () => import(/* webpackChunkName: '[login]' */ '~vb/login/RequestForAuthCSP'),
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                const regParams = store.getters.getRegParams || { isRegister: false };
                if(!regParams.isRegister) {
                    store.commit('REG_PARAMS', {});
                    Vue.$log.warn('※ User Register form Access not allowed.');
                    return next({ name: 'NoAuth' });

                } else {
                    Vue.$log.info('※ requestForAuthCSP check / to:', to.path, 'from:',from.path, 'qS:', queryStrings);
                    return next();
                }
            }
        },
        // No page registration in menu management => Unconditional 404 processing of user criteria regardless of component registration
        {
            name: 'EmptyPage',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/emptypage`,
            component: ErrorPage,
        },
        {
            name: '404',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/404`,
            component: ErrorPage,
        },
        {
            name: 'NoAuth',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/no_auth`,
            component: NoAuthPage,
        },
        {
            name: 'NoSession',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/no_session`,
            component: NoSessionPage
        },
        {
            name: 'Error',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/error`,
            component: ErrorPage,
        },
        // Admin
        {
            name: 'Admin',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/admin`,
            component: AdminMain,
            beforeEnter: (to, from, next) => {
                Vue.$log.info("※ Admin Path routing check. userRole");
                return checkMenuAccess(to, from, next);
            },
            children: [
                // 아래로 업무페이지 (폴더별로 추가)
                {
                    name: 'KnowledgeManager',
                    path: 'knowledgeManager',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/knowledgeManager/KnowledgeManagerMain'),
                    children: [
                        {
                            name: 'BoardManageList',
                            path: 'boardManage/boardManageList',
                            component: () => import(/* webpackChunkName: '[admin]' */ '~va/knowledgeManager/boardManage/BoardManageList'),
                        },
                        {
                            name: 'BoardManageDetail',
                            path: 'boardManage/boardManageDetail',
                            props: route => ({ boardId: route.query.BOARD_ID }),
                            component: () => import(/* webpackChunkName: '[admin]' */ '~va/knowledgeManager/boardManage/BoardManageDetail'),
                        },
                        {
                            name: 'BoardManageRegister',
                            path: 'boardManage/boardManageRegister',
                            component: () => import(/* webpackChunkName: '[admin]' */ '~va/knowledgeManager/boardManage/BoardManageRegister'),
                        },
                        {
                            name: 'ExpiredKnowledgeList',
                            path: 'expiredKnowledge/expiredKnowledgeList',
                            component: () => import(/* webpackChunkName: '[admin]' */ '~va/knowledgeManager/expiredKnowledge/ExpiredKnowledgeList'),
                        },
                        {
                            name: 'ExpiringKnowledgeList',
                            path: 'expiringKnowledge/expiringKnowledgeList',
                            component: () => import(/* webpackChunkName: '[admin]' */ '~va/knowledgeManager/expiringKnowledge/ExpiringKnowledgeList'),
                        },
                        {
                            name: 'TrashList',
                            path: 'trash/trashList',
                            component: () => import(/* webpackChunkName: '[admin]' */ '~va/knowledgeManager/trash/TrashList'),
                        },
                        {
//                            name: 'ApprovalManage',
                            name: 'ApprovalManageList',
                            path: 'approval/ApprovalManageList',
                            component: () => import(/* webpackChunkName: '[admin]' */ '~va/knowledgeManager/approval/ApprovalManageList'),
                        },
                    ]
                },
                {
                    name: 'StatisticsManagerImportantList',
                    path: 'statisticsManager/statisticsManagerImportantList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/ImportantList'),
                },
                {
                    name: 'StatisticsManagerUnreadList',
                    path: 'statisticsManager/statisticsManagerUnreadList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/UnreadList'),
                },
                {
                    name: 'StatisticsManagerByTeamList',
                    path: 'statisticsManager/byTeamList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/byTeamList'),
                },
                {
                    name: 'StatisticsManagerByKnowledgeList',
                    path: 'statisticsManager/byKnowledgeList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/byKnowledgeList'),
                },
                {
                    name: 'StatisticsManagerByProductCategoryList',
                    path: 'statisticsManager/byProductCategoryList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/byProductCategoryList'),
                },
                {
                    name: 'StatisticsManagerContentsStatisticsList',
                    path: 'statisticsManager/contentsStatisticsList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/contentsStatisticsList'),
                },
                {
                    name: 'StatisticsManagerRecommendationContentsList',
                    path: 'statisticsManager/recommendationContentsList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/recommendationContentsList'),
                },
                {
                    name: 'StatisticsManagerContentsStatisticsNewList',
                    path: 'statisticsManager/contentsSatisfactionNewList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/contentsSatisfactionNewList'),
                },
                {
                    name: 'StatisticsManagerContentsSatisfactionList',
                    path: 'statisticsManager/contentsSatisfactionList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/contentsSatisfactionList'),
                },
                {
                    name: 'StatisticsManagerLogInfoList',
                    path: 'statisticsManager/logInfoList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/logInfoList'),
                },
                {
                    name: 'StatisticsManagerReprocessRatioList',
                    path: 'statisticsManager/reprocessRatioList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/reprocessRatioList'),
                },
                {
                    name: 'StatisticsManagerGBMQnAStatusList',
                    path: 'statisticsManager/gBMQnAStatusList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/gBMQnAStatusList'),
                },
                {
                    name: 'StatisticsManagerQnAStatusList',
                    path: 'statisticsManager/qnAStatusList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/qnAStatusList'),
                },
                {
                    name: 'StatisticsManagerQnAReportByAnswererList',
                    path: 'statisticsManager/qnaReportByAnswererList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/qnaReportByAnswererList'),
                },
                {
                    name: 'StatisticsManagerByGBMList',
                    path: 'statisticsManager/byGBMList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/byGBMList'),
                },
                {
                    name: 'StatisticsManagerBySubsidiaryList',
                    path: 'statisticsManager/bySubsidiaryList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/bySubsidiaryList'),
                },
                {
                    name: 'MonthlyContentSatisfactionList',
                    path: 'statisticsManager/monthlyContentsSatisfactionList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/monthlyContentsSatisfactionList'),
                },
                {
                    name: 'MonthlyQnASatisfactionList',
                    path: 'statisticsManager/monthlyQnASatisfactionList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/monthlyQnASatisfactionList'),
                },
                {
                    name: 'MonthlyQnAStatusList',
                    path: 'statisticsManager/monthlyQnAStatusList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/statisticsManager/monthlyQnAStatusList'),

                },
                // view/admin/system/code/CodeAdminList
                {
                    name: 'CodeManagement',
                    path: 'system/code/CodeAdminList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/system/code/CodeAdminList'),
                },
                // view/admin/system/resource/ResourceAdminList
                {
                    name: 'ResourceManagement',
                    path: 'system/resource/ResourceAdminList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/system/resource/ResourceAdminList'),
                },
                {
                    name: 'RoleManagement',
                    path: 'system/userRole/AuthAdminList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/system/userRole/RoleAdminList'),
                },
                {
                    name: 'UserManagement',
                    path: 'user/UserMngList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/user/UserAdminList'),
                },
                {
                    name: 'MenuManagement',
                    path: 'system/menu/MenuAdminList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/system/menu/MenuAdminList'),
                },
                {
                    name: 'NoticeManagementList',
                    path: 'other/notice/NoticeList',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/other/NoticeList'),
                },
                {
                    name: 'NoticeManagementCreate',
                    path: 'other/notice/NoticeCreate',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/other/NoticeCreate'),
                },
                {
                    name: 'NoticeManagementModify',
                    path: 'other/notice/NoticeModify',
                    props: route => ({ seq: route.query.seq }),
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/other/NoticeModify'),
                },
                {
                    name: 'toolManageListGD',
                    path: 'tool/toolManageListGD',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/tool/toolManageList'),
                },
                {
                    name: 'toolManageListVD',
                    path: 'tool/toolManageListVD',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/tool/toolManageList'),
                },
                {
                    name: 'toolManageListHASS',
                    path: 'tool/toolManageListHASS',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/tool/toolManageList'),
                },
                {
                    name: 'toolManageDetail',
                    path: 'tool/toolManageDetail',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/tool/toolManageDetail'),
                },
                {
                    name: 'imageCloudList',
                    path: 'imagecloud/imageCloud',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/tool/imageCloudList'),
                },
                {
                    name: 'imageCloudDetail',
                    path: 'imagecloud/imageCloudDetail',
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/tool/imageCloudDetail'),
                },
            ],
        },
        // Admin QNA Manager
        {
            name: 'SKPAdmin',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/skp/basis/admin`,
            component: AdminMain,
            beforeEnter: (to, from, next) => {
                Vue.$log.info("※ Admin Path routing check. userRole");
                return checkMenuAccess(to, from, next);
            },
            children: [
                {
                    name: 'answererManageList',
                    path: `qnaManager/answererManage/answererManageList`,
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/qnaManager/answererManageList'),
                },
                {
                    name: 'inactiveAnswererList',
                    path: `qnaManager/inactiveAnswerer/inactiveAnswererList`,
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/qnaManager/inactiveAnswererList'),
                },
                {
                    name: 'qnaStatusList',
                    path: `qnaManager/qnaStaus/qnaStatusList`,
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/qnaManager/qnaStatusList'),
                },
                {
                    name: 'inquiryManageList',
                    path: `qnaManager/inquiryManage/inquiryManageList`,
                    component: () => import(/* webpackChunkName: '[admin]' */ '~va/qnaManager/inquiryManageList'),
                },
            ],
        },

        // HHP
        {
            name: 'anysvcMain',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/anysvcmobile`,
            // component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/main/SKPMain'),
            component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/HHPMain'),
            beforeEnter: hhpAccessCheck,
            children: [
                // Temporary Home Page
                {
                    name: 'anysvcHome',
                    path: 'home', // /basis/anysvcmobile/Home.skp
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/home/HHPHome'),
                    beforeEnter: hhpAccessCheck,
                },
                // {
                //     name: 'anysvcLogin',
                //     path: 'cert/login', // /basis/anysvcmobile/Home.skp
                //     component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/certificate/CertLogin'),
                // },
                // {
                //     name: 'anysvcCertPassChange',
                //     path: 'cert/passchange', // /basis/anysvcmobile/Home.skp
                //     component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/certificate/CertPassChange'),
                // },
                 {
                     name: 'anysvcNotice',
                     path: 'notice/noticeList', // /basis/anysvcmobile/Notice.skp
                     component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/notice/NoticeList'),
                 },
                 {
                     name: 'anysvcNoticeDetail',
                     path: 'notice/detail', // /basis/anysvcmobile/Notice.skp
                     component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/notice/NoticeDetail'),
                 },
                {
                    name: 'anysvcFindContent',
                    path: 'findcontent/FindContent',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/findContent/FindContent'),
                    beforeEnter: hhpAccessCheck,
                },
                // {
                //     name: 'hhpFindContentView',
                //     path: 'findContent/view',
                //     component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/findContent/FindContentView'),
                //     props: (route) => ({
                //         CTTID: route.query.CTTID.toString(),
                //         NMMODEL: route.query.NMMODEL,
                //         CDCODE: route.query.CDCODE,
                //         BUYER_CODE: route.query.BUYER_CODE,
                //         COUNTRY_NM: route.query.COUNTRY_NM,
                //         SKU_CODE: route.query.SKU_CODE,
                //         COUNTRY_CD: route.query.COUNTRY_CD,
                //      }),
                // },
                {
                    name: 'anysvcImeiReview',
                    path: 'imeiReview/IMEIReview',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/imeiReview/ImeiReview'),
                    beforeEnter: hhpAccessCheck,
                },
                {
                    name: 'hhpServiceBulletin',
                    path: 'svcBulletin/sbList',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/svcBulletin/BulletinList'),
                    beforeEnter: hhpAccessCheck,
                },
                {
                    name: 'hhpServiceBulletinCreate',
                    path: 'svcBulletin/sbRegister',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/svcBulletin/BulletinCreate'),
                },
                {
                    name: 'hhpServiceBulletinView',
                    path: 'svcBulletin/sbView',
                    props: (route) => ({ seq: route.query.seq }),
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/svcBulletin/BulletinView'),
                },
                {
                    name: 'hhpServiceBulletinEdit',
                    path: 'svcBulletin/sbEdit',
                    props: (route) => ({ seq: route.query.seq }),
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/svcBulletin/BulletinEdit'),
                },
                {
                    name: 'hhpServiceBulletinTranslate',
                    path: 'svcBulletin/sbReprocess',
                    props: (route) => ({ seq: route.query.seq }),
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/svcBulletin/BulletinTranslate'),
                },
                {
                    name: 'hhpServiceBulletinOther',
                    path: 'svcBulletin/sbOtherList',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/svcBulletin/BulletinOtherList'),
                    beforeEnter: hhpAccessCheck,
                },
                {
                    name: 'hhpServiceBulletinOtherView',
                    path: 'svcBulletin/sbOtherView',
                    props: (route) => ({ seq: route.query.seq }),
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/svcBulletin/BulletinOtherView'),
                },
                {
                    name: 'hhpServiceBulletinOtherEdit',
                    path: 'svcBulletin/sbOtherEdit',
                    props: (route) => ({ seq: route.query.seq }),
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/svcBulletin/BulletinOtherEdit'),
                },
                // {
                //     name: 'HHP Svc Bulletin View',
                //     path: 'svcBulletin/view',
                //     component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/svcBulletin/BulletinList'),
                // },
                // {
                //     name: 'HHP Svc Bulletin Other',
                //     path: 'svcBulletinOther',
                //     component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/svcBulletin/BulletinOtherList'),
                // },
                // {
                //     name: 'HHP Svc Bulletin View Other',
                //     path: 'svcBulletinOther/view',
                //     component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/svcBulletin/BulletinOtherView'),
                // },
                {
                    name: 'HHP Request Status',
                    path: 'request/Request',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/request/RequestStatus'),
                },
                {
                    name: 'hhpRequestCert',
                    path: 'request/RequestCert',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/request/RequestCert'),
                },
                {
                    name: 'hhpOtherRequest',
                    path: 'request/RequestOther',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/request/RequestOther'),
                },
                {
                    name: 'HHP First Approval',
                    path: 'approvalManagement/FirstApproval/FirstApproval',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/approvalManagement/FirstApprovalList'),
                    beforeEnter: hhpAccessCheck,
                },
                {
                    name: 'HHP Second Approval',
                    path: 'approvalManagement/SecondApproval/SecondApproval',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/approvalManagement/SecondApprovalList'),
                    beforeEnter: hhpAccessCheck,
                },
                {
                    name: 'HHP Approval Management',
                    path: 'approvalManagement/approvalMgmt/ApprovalMgmt',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/approvalManagement/ApprovalManagement'),
                    beforeEnter: hhpAccessCheck,
                },
                {
                    name: 'HHP Content History',
                    path: 'contenthistory/ContentHistory',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/contentHistory/ContentHistory'),
                    beforeEnter: hhpAccessCheck,
                },
                {
                    name: 'Code Management',
                    path: 'code/CodeMgt',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/code/CodeMgmt'),
                    beforeEnter: hhpAccessCheck,
                },
                // Label Position is NOT USED ANYMORE
                {
                    name: 'Label Position',
                    path: 'labelPrintPosition/LabelMain',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/label/LabelList'),
                },
                // {
                //     name: 'Label Position View',
                //     path: 'label/view',
                //     component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/label/LabelView'),
                // },
                {
                    name: 'hhpComMapMgmt',
                    path: 'comMapMgmt/ComMapMgmt',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/comMapMgmt/ComMapMgmt'),
                    beforeEnter: hhpAccessCheck,
                },
                {
                    name: 'hhpComMapMgmtB2B',
                    path: 'comMapMgmt/ComMapMgmtB2B', // /basis/anysvcmobile/comMapMgmt.skp
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/comMapMgmt/ComMapMgmtB2B'),
                    beforeEnter: hhpAccessCheck,
                },
                {
                    name: 'hhpEmToken',
                    path: 'EmToken/EmToken', // /basis/anysvcmobile/EmToken.skp
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/emToken/EmToken'),
                    beforeEnter: hhpAccessCheck,
                },
                {
                    name: 'hhpKrcMapMgmt',
                    path: 'KRCMapMgmt/KRCMapMgmt', // /basis/anysvcmobile/KRCMapMgmt.skp
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/KRCMapMgmt/KRCMapMgmt'),
                    beforeEnter: hhpAccessCheck,
                },
                {
                    name: 'requestImeiPwdUpdate',
                    path: 'request/RequestImeiPwdUpdate',  // /basis/anysvcmobile/request/RequestImeiPwdUpdate
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/request/RequestImeiPwdUpdate'),
                    beforeEnter: hhpAccessCheck,
                },
                // /basis/anysvcmobile/request/RequestImeiPwdUpdate

            ],
        },
        // Certificate
        {
            name: 'certificate',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/certificate`,
            component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/anysvcmobile/HHPMain'),
            beforeEnter: (to, from, next) => {
                return axios
                    .get(`${SDLUtil.API_URL}/basis/certificate/CertMain.skp`)
                    .then(response => {
                        Vue.$log.debug("CertMain.skp RESPONSE", response)
                        next();
                    })
                    .catch(err => {
                        Vue.$log.debug('CertMain.skp ERR', err);
                        if (err.data.error.code === 'HHP_CERT_REQUIRED') {
                            localStorage.setItem('hhp_redirect', to.path);
                            // next({ path: '/basis/certificate/CertLogin' });
                            next();

                        } else if (err.data.error.code === 'HHP_MONTH_LOCK') {
                            // localStorage.setItem('hhp_redirect', to.path);
                            // next({ path: '/basis/certificate/CertLogin' });
                            next();
                            // next({ path: '/basis/anysvcmobile/request/RequestOther' });

                        } else if (['HHP_FORBIDDEN'].includes(err.data.error.code)) {
                            next({ path: '/basis/certificate/CertWarning' });

                        } else {
                            Vue.$log.error('router unhandled case', err.data.error);
                            // alert('router unhandled case.' + err.data.error.code);
                            next();
                        }

                        // next({ path: err.data.error.message });
                    });
            },
            children: [
                {
                    name: 'anysvcCertHome',
                    path: 'CertMainIndex',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/certificate/CertLogin'),
                },
                {
                    name: 'anysvcCertPassChange',
                    path: 'CertPassChange',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/certificate/CertPassChange'),
                },
                {
                    name: 'anysvcCertLogin',
                    path: 'CertLogin',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/certificate/CertLogin'),
                },
                {
                    name: 'anysvcCertIssue',
                    path: 'CertIssue',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/certificate/CertLogin'),
                },
                {
                    name: 'anysvcCertAccessDenied',
                    path: 'CertWarning',
                    component: () => import(/* webpackChunkName: '[hhp]' */ '~vb/certificate/CertAccessDenied'),
                },
            ],
        },
        // Main
        {
            name: 'Main',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/main`,
            alias: '/',
            component: SKPMain,
            beforeEnter: async (to, from, next) => {
                let connSystem = store.getters.getConnSystem || '';
                if(!StringUtil.isNull(connSystem) && connSystem === 'SCMS') {
                    let popupParams = store.getters.getPopupParams || {};
                    return next({ path: '/no_auth' });

                } else {
                    return next();
                }
            },
            children: [
                // 아래로 업무페이지 (폴더별로 추가)
                // Dashboard
                {
                    name: 'Dashboard',
                    path: '/main',
                    component: () => {
                        // Admin / ASC 분기 처리
                        let deptLevelCd = store.getters.getDeptLevelCd || 1;
                        if(Number(deptLevelCd) === 1) {
                            // ASC Search Page
                            return import(/* webpackChunkName: '[main]' */ '~vb/dashboard/SearchPage');

                        } else {
                            // SKP Dashboard Page
                            return import(/* webpackChunkName: '[main]' */ '~vb/dashboard/Dashboard');
                        }
                    },
                },
                // My Knowledge
                {
                    name: 'MyPage',
                    path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/myKnowledge/`,
                    component: () => import(/* webpackChunkName: '[myKnowledge]'*/ '~vb/myKnowledge/MyKnowledge'),
                    children: [
                        {
                            name: 'MySetting',                  /* My Setting */
                            path: 'userPreferences/userPreferences/userPreferencesDetail',
                            component: () => import(/* webpackChunkName: '[myKnowledge]'*/ '~vb/myKnowledge/userPreferences/UserPreferencesDetail'),
                        },
                        {
                            name: 'MyKnowledge',                /* My Knowledge */
                            path: 'myKnowledge/register/registerList',
                            component: () => import(/* webpackChunkName: '[myKnowledge]'*/ '~vb/myKnowledge/myKnowledge/RegisterList'),
                        },
                        {
                            name: 'MyBugReport',                /* My Bug Report */
                            path: 'myKnowledge/bugReport/bugReportList',
                            component: () => import(/* webpackChunkName: '[myKnowledge]'*/ '~vb/myKnowledge/bugReport/BugReportList'),
                        },
                        {
                            name: 'MyBugReportDetail',          /* My Bug Report */
                            path: 'myKnowledge/bugReport/bugReportDetail',
                            props: route => ({ bugReportId: route.query.BUG_REPORT_ID }),
                            component: () => import(/* webpackChunkName: '[myKnowledge]'*/ '~vb/myKnowledge/bugReport/BugReportDetail'),
                        },
                        {
                            name: 'ServiceScriptList',          /* My Reprocess List */
                            path: 'serviceScript/serviceScriptList',
                            component: () => import(/* webpackChunkName: '[myKnowledge]'*/ '~vb/myKnowledge/serviceScript/ServiceScriptList'),
                        },
                        {
                            name: 'ServiceScriptDetail',        /* My Reprocess Detail */
                            path: 'serviceScript/serviceScriptDetail',
                            props: route => ({ knowledgeId: route.query.KNOWLEDGE_ID, serviceScriptId: route.query.SERVICE_SCRIPT_ID, showType: route.query.TYPE }),
                            component: () => import(/* webpackChunkName: '[myKnowledge]'*/ '~vb/myKnowledge/serviceScript/ServiceScriptDetail'),
                        },
                        {
                            name: 'MyFavoriteContentsList',     /* My Favorite */
                            path: 'myFavoriteContents/favoriteContentsList',
                            component: () => import(/* webpackChunkName: '[myKnowledge]'*/ '~vb/myKnowledge/myFavoriteContents/FavoriteContentsList'),
                        },
                        {
                            name: 'MyFavoriteContentsDetail',   /* My Favorite */
                            path: 'myFavoriteContents/favoriteContentsDetail',
                            props: route => ({ knowledgeId: route.query.KNOWLEDGE_ID }),
                            component: () => import(/* webpackChunkName: '[myKnowledge]'*/ '~vb/myKnowledge/myFavoriteContents/FavoriteContentsDetail'),
                        },
                        // /basis/myKnowledge/myKnowledge/register/registerForm
                        /*,
                        {
                            name: 'MyFavoriteContents',
                            path: 'serviceScript/serviceScriptList',
                            component: () => import(),
                        }
                        */
                    ]
                },
                // Search by namgab.kim
                {
                    name: 'Search',
                    path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/intgSearch/`,
                    component: () => import(/* webpackChunkName: '[intgSearch]'*/ '~vb/intgSearch/Search'),
                    children: [
                        {
                            name: 'SearchList',
                            path: `SearchList`,
                            component: () => import(/* webpackChunkName: '[intgSearch]' */ '~vb/intgSearch/SearchList'),
                        }
                    ]
                },
                // SearchAsc by namgab.kim
                {
                    name: 'SearchAsc',
                    path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/intgSearch/`,
                    component: () => import(/* webpackChunkName: '[intgSearch]'*/ '~vb/intgSearch/SearchAsc'),
                    children: [
                        {
                            name: 'SearchAscList',
                            path: `SearchAscList`,
                            component: () => import(/* webpackChunkName: '[intgSearch]' */ '~vb/intgSearch/SearchAscList'),
                        }
                    ]
                },
                // Knowledge
                {
                    name: 'Knowledge',
                    path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/knowledge`,
                    component: () => import(/* webpackChunkName: '[knowledge]' */ '~vb/knowledge/Knowledge'),
                    children: [
                        {
                            name: 'KnowledgeList',
                            path: 'knowledgeList',
                            props: route => ({ boardId: route.query.BOARD_ID }),
                            component: () => import(/* webpackChunkName: '[knowledge]' */ '~vb/knowledge/KnowledgeList'),
                            beforeEnter: checkBoardAccess
                        },
                        {
                            name: 'KnowledgeDetail',
                            path: 'knowledgeDetail',
                            props: route => ({ knowledgeId: route.query.KNOWLEDGE_ID, boardId: route.query.boardId }),
                            component: () => import(/* webpackChunkName: '[knowledge]' */ '~vb/knowledge/KnowledgeDetail'),
                            beforeEnter: checkBoardAccess
                        },
                    ],
                },
                // Exploded View
                {
                    name: 'ExplodedView',   // "/basis/explodedView/explodedModelList.skp"
                    path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/explodedView`,
                    component: () => import(/* webpackChunkName: '[explodedView]' */ '~vb/explodedView/ExplodedView'),
                    children: [
                        {
                            name: 'ExplodedModelList',
                            path: 'explodedModelList',
                            props: route => ({ boardId: route.query.BOARD_ID }),
                            component: () => import(/* webpackChunkName: '[explodedView]' */ '~vb/explodedView/ExplodedModelList'),
                        },
                    ],
                },
                // 3D Exploded View disabled
                // {
                //     name: 'ThreeDExplodedView',   // "/basis/explodedView/threeDExplodedModelList.skp"
                //     path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/explodedView`,
                //     component: () => import(/* webpackChunkName: '[threeDExplodedView]' */ '~vb/explodedView/ThreeDExplodedView'),
                //     children: [
                //         {
                //             name: 'ThreeDExplodedModelList',
                //             path: 'threeDExplodedModelList',
                //             props: route => ({ boardId: route.query.BOARD_ID }),
                //             component: () => import(/* webpackChunkName: '[threeDExplodedView]' */ '~vb/explodedView/ThreeDExplodedModelList'),
                //         },
                //     ],
                // },
                // 3D Exploded View disabled
                // {
                //     name: 'ThreeDExplodedViewSearch',   // "/basis/explodedView/threeDExplodedModelList.skp"
                //     path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/explodedView`,
                //     component: () => import(/* webpackChunkName: '[threeDExplodedView]' */ '~vb/explodedView/ThreeDExplodedViewSearch'),
                //     children: [
                //         {
                //             name: 'ThreeDExplodedModelSearchList',
                //             path: 'threeDExplodedModelSearchList',
                //             props: route => ({ boardId: route.query.BOARD_ID }),
                //             component: () => import(/* webpackChunkName: '[threeDExplodedView]' */ '~vb/explodedView/ThreeDExplodedModelSearchList'),
                //         },
                //     ],
                // },
                // Faq
                {
                    name: 'faqMain',
                    path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/faq`,
                    component: () => import(/* webpackChunkName: '[faq]' */ '~vb/faq/common/faqMain'),
                    children: [
                        {
                            name: 'createNewFAQ',
                            path: 'faqForm',
                            component: () => import(/* webpackChunkName: '[faq]' */ '~vb/faq/createNewFAQ'),
                        },
                        {
                            name: 'viewFAQ',
                            path: 'faqList',
                            component: () => import(/* webpackChunkName: '[faq]' */ '~vb/faq/viewFAQ'),
                        },
                        {
                            name: 'viewFAQNew',
                            path: 'faqListNew',
                            component: () => import(/* webpackChunkName: '[faq]' */ '~vb/faq/viewFAQ'),
                        },
                    ],
                },
                // Qna
                {
                    name: 'mainQuestion',
                    path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/qna`,
                    component: () => import(/* webpackChunkName: '[qna]' */ '~vb/faq/common/faqMain'),
                    children: [
                        {
                            name: 'createNewQuestion',
                            path: `createNewQuestion`,
                            component: () => import(/* webpackChunkName: '[qna]' */ '~vb/qna/createNewQuestion'),
                        },
                        {
                            name: 'newQuestionList',
                            path: `newQuestionList`,
                            component: () => import(/* webpackChunkName: '[qna]' */ '~vb/qna/newQuestionList'),
                        },
                    ],
                },
                // MyQna
                {
                    name: 'myMainQuestion',
                    path: `${SDLUtil.WEB_CONTEXT_PATH}/skp/basis/myKnowledge/myQnA`,
                    /*alias: `${SDLUtil.WEB_CONTEXT_PATH}/skp/basis/myKnowledge/myQnA/toAnswer/toAnswerListNew`,*/
                    component: () => import(/* webpackChunkName: '[qna]' */ '~vb/faq/common/faqMain'),
                    children: [
                        {
                            name: 'questionDetail',
                            path: `myQuestion/questionDetail`,
                            component: () => import(/* webpackChunkName: '[qna]' */ '~vb/qna/questionDetail'),
                        },
                        {
                            name: 'questionList',
                            path: `myQuestion/myQuestionList`,
                            component: () => import(/* webpackChunkName: '[qna]' */ '~vb/qna/questionList'),
                            props: route => ({ isSurvey: route.query.isSurvey }),
                        },
                        {
                            name: 'answerDetail',
                            path: `toAnswer/answerDetail`,
                            component: () => import(/* webpackChunkName: '[qna]' */ '~vb/qna/answerDetail'),
                        },
                        {
                            name: 'answerList',
                            path: `toAnswer/toAnswerList`,
                            component: () => import(/* webpackChunkName: '[qna]' */ '~vb/qna/answerList'),
                        },
                        {
                            name: 'answerListNew',
                            path: `toAnswer/toAnswerListNew`,
                            component: () => import(/* webpackChunkName: '[qna]' */ '~vb/qna/answerList'),
                        },
                    ],
                },
                // Samsung.com
                {
                    name: 'SamsungDotCom',
                    path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/main/dotComSupportMenuLink`,
                    props: route => ({ dotComMenuNm: route.query.dotComMenuNm }),
                    beforeEnter: (to, from, next) => {
                        Vue.$log.info("※ SamsungDotCom Path routing check by User Menu =>", to.fullPath);
                        let searchMenuList = MenuUtil.menuScanByUrlEx(to.fullPath, store.getters.getMenus);
                        let idx = _.findIndex(searchMenuList, function(m){ return m.currMenu === true });
                        // SamsungDotcom 권한을 내가 가진 메뉴에서 URL 비교
                        if( idx > -1 ) {
                            next();

                        } else {
                            alert('Check your role and try again.');
                            next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/` });
                        };
                    },
                    component: () => import(/* webpackChunkName: '[dotcom]' */ '~vb/main/DotComMain')
                },

                // CMS Contents
                {
                    name: 'cmsContents',
                    path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/cmsContents/`,
                    component: () => import(/* webpackChunkName: '[cms]' */ '~vb/knowledge/Knowledge'),
                    children: [
                        {
                            name: 'cmsByModelCode',
                            path: 'cmsByModelcode',
                            component: () => import(/* webpackChunkName: '[cms]' */ '~vb/cmsContents/CmsByModelCode'),
                        },
                        {
                            name: 'cmsCategorySearch',
                            path: 'cmsContentsList',
                            component: () => import(/* webpackChunkName: '[cms]' */ '~vb/cmsContents/CmsCategorySearch'),
                        },
                    ],
                },
                // Customer > DotCom > Support ( 김남갑 )
                {
                    name: 'custDotcom',
                    path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/customer`,
                    component: () => import(/* webpackChunkName: '[dotcom]'*/ '~vb/dotcom/DotCom'),
                    children: [
                        {
                            name: 'dotComQaList',
                            path: `dotcom/DotComQaList`,
                            component: () => import(/* webpackChunkName: '[dotcom]' */ '~vb/dotcom/DotComQaList'),
                        }
                    ]
                }
            ]
        },
        /* 지식 컨텐츠 등록 (팝업으로 인해 단독으로 실행, 별도 분리) */
        {
            name: 'RegisterForm',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/myKnowledge/myKnowledge/register/registerForm`,
            component: () => import(/* webpackChunkName: '[registerForm]'*/ '~vb/myKnowledge/Register'),
        },
        {
            name: 'KnowledgeDetailViewer',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/mail/knowledgeViewer`,
            props: route => ({ sk: route.query.sk }),
            component: () => import(/* webpackChunkName: '[knowledge]'*/ '~vb/common/KnowledgeViewer')
        },
        {
            name: 'serviceBulletinViewer',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/mail/serviceBulletinViewer`,
            props: route => ({ sk: route.query.sk }),
            component: () => import(/* webpackChunkName: '[knowledge]'*/ '~vb/common/ServiceBulletinViewer')
        },
        {
            name: 'KnowledgeMail',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/mail/viewer`,
            component: () => import(/* webpackChunkName: '[knowledge]'*/ '~vb/common/MailViewer'),
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ Mail viewer Connection Login Check. to:', to.path, 'from:', from.path, 'qS:', queryStrings);
                let params = {
                    // GSPNEncrypt parameter
                    userId: queryStrings.userid,            // 사용자ID
                    companyCode: queryStrings.companycode,  // 법인코드
                    viewName: queryStrings.viewname,        // 화면 분기 구분코드
                    knowledgeId: queryStrings.knowledgeid,
                    boardId: queryStrings.boardid,
                    expiration: queryStrings.expiration,

                    // Non-encrypt plain parameter
                    connectRoot: 'GSPN',
                    language: StringUtil.nvl(queryStrings.language, 'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'), // 언어
                    dateFormat: StringUtil.nvl(queryStrings.dateformat, 'MM.dd.yyyy'), // 날짜 포멧
                    timeFormat: StringUtil.nvl(queryStrings.timeformat, 'a_hh@mm@ss'), // 시간 포멧
                    timeZone: StringUtil.nvl(queryStrings.timezone, 'Asia/Seoul'), // 타임 존
                    gtiYn: 'Y'
                };

                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginMailCheck.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        let resObj = JSON.parse(res.data.userInfo);
                        store.dispatch('setLoginFromOtherSystem', res).then(isAuth => {
                            if (isAuth) {
                                next();

                            } else {
                                Vue.$log.error('※ Mail viewer Connection Login error', isAuth);
                                alert('No register login user. This system is not available.');
                                next({ path: '/no_auth' });
                            }
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ Mail viewer Connection Login Check error', err);
                        alert("No register login user. This system is not available.");
                        next({ path: '/no_auth' });
                    });
            }
        },
        // GSPN SVC Tool
        {
            name: 'GSPNConNew',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/gspnCon/commonConnectNew`,
            component: () => import(/* webpackChunkName: '[gspnCon]'*/ '~vb/gspnCon/GSPNConMain'),
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ GSPN Common Connection New Login Check. to:', to.path, 'from:', from.path, 'qS:', queryStrings);
                if( SDLUtil.isLogin() && ( StringUtil.isNull(queryStrings.commonparam) ) ) {
                    return next();

                } else {
                    let params = {
                        // GSPNEncrypt parameter
                        commonParam: queryStrings.commonparam,  // 사용자ID

                        // Non-encrypt plain parameter
                        connectRoot: 'GSPN',
                        language: StringUtil.nvl(queryStrings.language, 'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'), // 언어
                        dateFormat: StringUtil.nvl(queryStrings.dateformat, 'MM.dd.yyyy'), // 날짜 포멧
                        timeFormat: StringUtil.nvl(queryStrings.timeformat, 'a_hh@mm@ss'), // 시간 포멧
                        timeZone: StringUtil.nvl(queryStrings.timezone, 'Asia/Seoul'), // 타임 존
                        gtiYn: 'Y'
                    };

                    return axios.post(
                            `${SDLUtil.API_URL}/noauth/login/loginFromGSPN.skp`,
                            qs.stringify(params),
                            { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                        )
                        .then(res => {
                            let resObj = JSON.parse(res.data.userInfo);
                            store.dispatch('setLoginFromOtherSystem', res).then(isAuth => {
                                if (isAuth) {
                                    next({ name: 'GSPNConKnowledgeList' });

                                } else {

                                    Vue.$log.error('※ GSPN Login Check error', isAuth);
                                    alert('No register login user. This system is not available.');
                                    next({ path: '/no_auth' });
                                }
                            });
                        })
                        .catch(err => {
                            Vue.$log.error('※ GSPN Common Connection Login Check error', err);
                            alert("No register login user. This system is not available.");
                            next({ path: '/no_auth' });
                        });
                }
            },
            children: [
                {
                    name: 'GSPNConKnowledgeList',
                    path: 'list',
                    alias: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/gspnCon/svcToolList`,
                    component: () => import(/* webpackChunkName: '[gspnCon]' */ '~vb/gspnCon/SvcToolList'),
                },
                {
                    name: 'GSPNConKnowledgeDetail',
                    path: 'detail',
                    alias: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/gspnCon/svcToolDetail`,
                    props: route => ({ knowledgeId: route.query.knowledgeId, boardId: route.query.boardId, type: route.query.type }),
                    component: () => import(/* webpackChunkName: '[gspnCon]' */ '~vb/gspnCon/SvcToolDetail'),
                },
            ]
        },
        // GSPN New Question
        {
            name: 'GSPNConQuestion',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/gspnCon/`,
            component: () => import(/* webpackChunkName: '[gspnCon]' */ '~vb/faq/common/faqMain'),
            children: [
                {
                    name: 'newQuestionConnect',
                    path: `newQuestionConnect`,
                    component: () => import(/* webpackChunkName: '[gspnCon]' */ '~vb/qna/newQuestionList'),
                },
            ],
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ GSPN Common Connection New Question Login Check. to:', to.path, 'from:', from.path, 'qS:', queryStrings);
                let params = {
                    // GSPNEncrypt parameter
                    userId: queryStrings.userid,            // 사용자ID
                    companyCode: queryStrings.companycode,  // 법인코드
                    cttType: queryStrings.ctttype,          // 모델 코드 대응 (TODO ctType 인지 cttType 인지 확인)

                    // Support 접근
                    topMenuType     : 1,
                    loadMenuKind    : `${constants.SYSTEM_LOAD_MENU_SUP}`,
                    loginSystem     : `${constants.LOGIN_SYS_CS}`,

                    // Non-encrypt plain parameter
                    connectRoot: 'GSPN',
                    language: StringUtil.nvl(queryStrings.language, 'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'), // 언어
                    dateFormat: StringUtil.nvl(queryStrings.dateformat, 'MM.dd.yyyy'), // 날짜 포멧
                    timeFormat: StringUtil.nvl(queryStrings.timeformat, 'a_hh@mm@ss'), // 시간 포멧
                    timeZone: StringUtil.nvl(queryStrings.timezone, 'Asia/Seoul'), // 타임 존
                    gtiYn: 'Y'
                };

                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginFromGSPN.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        let resObj = JSON.parse(res.data.userInfo);
                        store.dispatch('setLoginFromOtherSystem', res).then(isAuth => {
                            if (isAuth) {
                                next();

                            } else {
                                Vue.$log.error('※ GSPN Login Check error', isAuth);
                                alert('No register login user. This system is not available.');
                                next({ path: '/no_auth' });
                            }
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ GSPN Common Connection Login Check error', err);
                        alert("No register login user. This system is not available.");
                        next({ path: '/no_auth' });
                    });
            }
        },
        // GSPN Parts 강내원 
        {
            name: 'GSPNConParts',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/gspnCon/commonConnectParts`,
            component: () => import(/* webpackChunkName: '[gspn]' */ '~vb/gspnCon/CommonConnectParts'),
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ GSPN Common Connection Login Check. to:', to.path, 'from:', from.path, 'qS:', queryStrings);
                let params = {
                    // GSPNEncrypt parameter
                    userId: queryStrings.userid,            // 사용자ID
                    companyCode: queryStrings.companycode,  // 법인코드
                    viewName: queryStrings.viewname,        // 화면 분기 구분코드
                    partsCode: queryStrings.partscode,      // 검색할 자재코드
                    modelCode: queryStrings.partscode,      // 검색할 모델코드  // parts 를 모델에 임의 저장해서 사용 
                    knowledgeId: queryStrings.knowledgeid,
                    boardId: queryStrings.boardid,

                    // Non-encrypt plain parameter
                    connectRoot: 'GSPN',
                    language: StringUtil.nvl(queryStrings.language, 'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'), // 언어
                    dateFormat: StringUtil.nvl(queryStrings.dateformat, 'MM.dd.yyyy'), // 날짜 포멧
                    timeFormat: StringUtil.nvl(queryStrings.timeformat, 'a_hh@mm@ss'), // 시간 포멧
                    timeZone: StringUtil.nvl(queryStrings.timezone, 'Asia/Seoul'), // 타임 존
                    gtiYn: 'Y'
                };
                
                //alert(" queryStrings.userid:"+queryStrings.userid);
                //alert(" queryStrings.partsCode:"+queryStrings.partscode);
//                alert(" queryStrings.viewname:"+queryStrings.viewname);
                //alert(" queryStrings.companycode:"+queryStrings.companycode);
//                alert(" queryStrings.modelCode:"+queryStrings.modelCode);
//                alert(" queryStrings.knowledgeid:"+queryStrings.knowledgeid);
//                alert(" queryStrings.boardid:"+queryStrings.boardid);
                //alert(" to.fullPath:"+to.fullPath);
                
                //console.log('Params:::::'+ params);
                Vue.$log.info('※ GSPN send Params =>', params);

                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginFromGSPN.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        let resObj = JSON.parse(res.data.userInfo);
                        store.dispatch('setLoginFromOtherSystem', res).then(isAuth => {
                            if (isAuth) {
                                next();
                            } else {
                                Vue.$log.error('※ GSPN Login Check error', isAuth);
                                alert('No register login user. This system is not available.');
                                next({ path: '/no_auth' });
                            }
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ GSPN Common Connection Login Check error', err);
                        alert("No register login user. This system is not available.");
                        next({ path: '/no_auth' });
                    });
            }
        },
        // GSPN 김남갑
        {
            name: 'GSPNCon',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/gspnCon/commonConnect`,
            component: () => import(/* webpackChunkName: '[gspn]' */ '~vb/gspnCon/CommonConnect'),
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ GSPN Common Connection Login Check. to:', to.path, 'from:', from.path, 'qS:', queryStrings);
                let params = {
                    // GSPNEncrypt parameter
                    userId: queryStrings.userid,            // 사용자ID
                    companyCode: queryStrings.companycode,  // 법인코드
                    viewName: queryStrings.viewname,        // 화면 분기 구분코드
                    modelCode: queryStrings.modelcode,      // 검색할 모델코드
                    knowledgeId: queryStrings.knowledgeid,
                    boardId: queryStrings.boardid,

                    // Non-encrypt plain parameter
                    connectRoot: 'GSPN',
                    language: StringUtil.nvl(queryStrings.language, 'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'), // 언어
                    dateFormat: StringUtil.nvl(queryStrings.dateformat, 'MM.dd.yyyy'), // 날짜 포멧
                    timeFormat: StringUtil.nvl(queryStrings.timeformat, 'a_hh@mm@ss'), // 시간 포멧
                    timeZone: StringUtil.nvl(queryStrings.timezone, 'Asia/Seoul'), // 타임 존
                    gtiYn: 'Y'
                };

                Vue.$log.info('※ GSPN send Params =>', params);

                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginFromGSPN.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                        let resObj = JSON.parse(res.data.userInfo);
                        store.dispatch('setLoginFromOtherSystem', res).then(isAuth => {
                            if (isAuth) {
                                next();
                            } else {
                                Vue.$log.error('※ GSPN Login Check error', isAuth);
                                alert('No register login user. This system is not available.');
                                next({ path: '/no_auth' });
                            }
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ GSPN Common Connection Login Check error', err);
                        alert("No register login user. This system is not available.");
                        next({ path: '/no_auth' });
                    });
            }
        },
        // GSPN knowledge detail viewer 강내원 
        {
            name: 'GSPNConnectBulletin',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/gspnCon/commonConnectBulletin`,
            component: () => import(/* webpackChunkName: '[gspn]' */ '~vb/gspnCon/CommonConnectBulletin'),
            props: route => ({ sk:
            {
                // GSPNEncrypt parameter
            	 userId: route.query.userId,            // 사용자ID
                 companyCode: route.query.companyCode,  // 법인코드
                 modelCode: route.query.modelCode,      // 검색할 모델코드  // parts 를 모델에 임의 저장해서 사용 
                 knowledgeId: route.query.knowledgeId,
            }
            }),
            beforeEnter: (to, from, next) => {
                const queryStrings = StringUtil.getAllUrlParams(to.fullPath);
                Vue.$log.info('※ GSPN Common Connection Login Check. to:', to.path, 'from:', from.path, 'qS:', queryStrings);
                let params = {
                    // GSPNEncrypt parameter
                    userId: queryStrings.userid,            // 사용자ID
                    companyCode: queryStrings.companycode,  // 법인코드
                    modelCode: queryStrings.modelcode,      // 검색할 모델코드  // parts 를 모델에 임의 저장해서 사용 
                    knowledgeId: queryStrings.knowledgeid,
                    connectRoot: 'GSPN',
                    language: StringUtil.nvl(queryStrings.language, 'en') === 'ko' ? 'en' : StringUtil.nvl(queryStrings.language, 'en'), // 언어
                    gtiYn: 'Y'
                };              
                Vue.$log.info('※ GSPN send Params =>', params);
                return axios.post(
                        `${SDLUtil.API_URL}/noauth/login/loginFromGSPN.skp`,
                        qs.stringify(params),
                        { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
                    )
                    .then(res => {
                    	let resObj = JSON.parse(res.data.userInfo);
                        store.dispatch('setLoginFromOtherSystem', res).then(isAuth => {
                           if (isAuth) {
                              next();
                            } else {
                                Vue.$log.error('※ GSPN Login Check error', isAuth);
                                alert('No register login user. This system is not available.');
                                next({ path: '/no_auth' });
                            }
                        });
                    })
                    .catch(err => {
                        Vue.$log.error('※ GSPN Common Connection Login Check error', err);
                        alert("No register login user. This system is not available.");
                        next({ path: '/no_auth' });
                    });
            }
        },
        // AccessTestPage  김남갑
        {
            name: 'AccessTest',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/pageAccess`,
            component: () => import(/* webpackChunkName: '[access]' */ '~vb/gspnCon/PageAccess')
        },
        { // 구주 로그인 - 김남갑
            name: 'EurLoginUser',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/login`,
            component: () => import(/* webpackChunkName: '[access]' */ '~vb/eur/EurLoginUser')
        },
        { // 공사중 - 김남갑
            name: 'UnderConstruction',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/wait`,
            component: () => import(/* webpackChunkName: '[access]' */ '~vb/eur/UnderConstr')
        },
        { // 구주 회원가입 Step1 - 김남갑
            name: 'EurJoinUserStep1',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/joinUserStep1`,
            component: () => import(/* webpackChunkName: '[access]' */ '~vb/eur/user/JoinUserStep1')
        },
        { // 구주 회원가입 AgreeView - Privacy Policy - 김남갑
            name: 'EurAgreeViewPolicy',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/agreeViewPolicy`,
            component: () => import(/* webpackChunkName: '[access]' */ '~vb/eur/user/AgreeViewPrivacyPolicy')
        },
        { // 구주 회원가입 AgreeView - Terms and Conditions - 김남갑
            name: 'EurAgreeViewTerms',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/agreeViewTerms`,
            component: () => import(/* webpackChunkName: '[access]' */ '~vb/eur/user/AgreeViewTermsCondt')
        },
        { // 구주 회원가입 Step2 - 김남갑
            name: 'EurJoinUserStep2',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/joinUserStep2`,
            component: () => import(/* webpackChunkName: '[access]' */ '~vb/eur/user/JoinUserStep2')
        },
        { // 구주 회원가입 Step3 - 김남갑
            name: 'EurJoinUserStep3',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/joinUserStep3`,
            component: () => import(/* webpackChunkName: '[access]' */ '~vb/eur/user/JoinUserStep3')
        },
        { // 비인가수리업자 - 수리정보 요청 이력 목록(Main Page for Repairer)
            name: 'RepairInfoHist',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/repairInfoHist`,
            component: () => import(/* webpackChunkName: '[access]' */ '~vb/eur/user/MyRepairInfoHistory')
        },
        { // 비인가수리업자 - Insert TermsAndCondition - 김남갑
            name: 'insertTerms',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/insertTerms`,
            component: () => import(/* webpackChunkName: '[access]' */ '~vb/eur/user/InsertTermsCond')
        },
        { // 비인가수리업자 - 수리정보 요청 (Page which after request)
            name: 'requestRepairInfo',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/requestRepairInfo`,
            component: () => import(/* webpackChunkName: '[access]' */ '~vb/eur/EurUserMain')
        },
        { // 비인가수리업자 - VOC 요청
            name: 'requestQuestion',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/requestQuestion`,
            component: () => import(/* webpackChunkName: '[access]' */ '~vb/eur/EurUserMain')
        },
        { // 비인가수리업자 - 수리정보 열람
            name: 'requestContents',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp/requestContents`,
            props: route => ({ sk: route.query.sk }),
            component: () => import(/* webpackChunkName: '[access]' */ '~vb/eur/user/RequestContents')
        },
        // Admin ERP Manager
        {
            name: 'ERPAdmin',
            path: `${SDLUtil.WEB_CONTEXT_PATH}/erp`,
            component: ErpMain,
            beforeEnter: (to, from, next) => {
                // Vue.$log.info("※ Admin Path routing check. userRole");
                // return checkMenuAccess(to, from, next);
                let connSystem = store.getters.getConnSystem || '';
                if (!StringUtil.isNull(connSystem) && connSystem === 'SCMS') {
                    let popupParams = store.getters.getPopupParams || {};
                    return next({ path: '/no_auth' });

                } else {
                    return next();
                }
            },
            children: [
                { // ERP 승인요청관리
                    name: 'requestManagerList',
                    path: `requestManagerList`,
                    component: () => import(/* webpackChunkName: '[admin]' */ '~vb/eur/admin/RequestManagerList'),
                },
                { // ERP VOC 관리
                    name: 'requestVocList',
                    path: `requestVocList`,
                    component: () => import(/* webpackChunkName: '[admin]' */ '~vb/eur/voc/RequestVocList'),
                },
                { // ERP 국가별 기준정보 관리
                    name: 'EurAdminSetCountry',
                    path: `adminSettingCountry`,
                    component: () => import(/* webpackChunkName: '[admin]' */ '~vb/eur/admin/SettingByCountryList'),
                },
                { // 국가별 승인자 결재선 관리
                    name: 'EurApproverCountry',
                    path: `adminApproverCountry`,
                    component: () => import(/* webpackChunkName: '[admin]' */ '~vb/eur/admin/ApproverByCountryList'),
                },
                { // 요청/승인 이력 관리 - 김남갑
                    name: 'EurReqApprHistories',
                    path: `adminReqApprHistories`,
                    component: () => import(/* webpackChunkName: '[admin]' */ '~vb/eur/admin/ReqApprHistoryList'),
                }
            ],
        },
        /*
         * otherwise redirect to home
         * [중요] 해당 Path 는 맨 마지막에 위치해야 함.
         */
        {
            path: '/*',
            redirect: `${SDLUtil.WEB_CONTEXT_PATH}/error`
        },
    ],
});

router.beforeEach((to, from, next) => {
    Vue.$log.info('※ 0) Login System :', store.getters.getLoginSystem, "routing path / From : '", from.path, "' -> To : '", to.path, "'");
    // redirect to login page if not logged in and trying to access a restricted page
    const commonPages   = ['/logout', '/error', '/no_auth', '/pageAccess'];
    // Login Access URL
    const loginPages = ['/Sensp560', '/gspnLogin', '/supportLogin', '/gspnERPLogin', '/cspLogin', '/cspSupportLogin', '/cspERPLogin', '/mgspnLogin', '/msupportLogin', '/scmsLogin', '/scmsKnowledgeLogin', '/scmsSupportLogin'];
    // Register Access URL
    const registerPages = ['/registerAccess', '/requestForAuth', '/registerAccessCSP', '/requestForAuthCSP'];
    // GSPN Common Connection Page URL
    const gspnConPages  = ['/basis/common/gspnCon/commonConnect',
                           '/basis/common/gspnCon/commonConnectNew',
                           '/basis/common/gspnCon/commonConnectNew/list',
                           '/basis/common/gspnCon/commonConnectNew/detail',
                           '/basis/common/gspnCon/gdFileConnect',
                           '/basis/common/gspnCon/newQuestionConnect',
                           '/basis/common/gspnCon/commonConnectParts',
                           '/basis/common/gspnCon/commonConnectBulletin'];
    const mailViewer    = ['/basis/common/mail', '/basis/common/mail/viewer', '/basis/common/mail/knowledgeViewer','/basis/common/mail/serviceBulletinViewer'];

    // EUR Parts
    const eurPages = ['/erp/login',
        '/erp/wait',
        '/erp/joinUserStep1',
        '/erp/joinUserStep2',
        '/erp/joinUserStep3',
        '/erp/requestRepairInfo',
        '/erp/requestQuestion',
        '/erp/requestContents',
        '/erp/agreeViewPolicy',
        '/erp/agreeViewTerms',
        '/erp/agreeViewDisclos',
        '/erp/repairInfoHist',
        '/erp/insertTerms' /* Insert Terms and Condition */
    ];

    const publicPages = _.union(commonPages, loginPages, registerPages, gspnConPages, mailViewer, eurPages).map(page => SDLUtil.WEB_CONTEXT_PATH + page);

    const queryStrings  = StringUtil.getAllUrlParams(to.fullPath);
    const authRequired  = !publicPages.includes(to.path);
    const loggedIn      = SDLUtil.isLogin();

    Vue.$log.info('※ 1) [authReq:', authRequired, '/loggedIn:', loggedIn, '] to.fullPath => ', to.fullPath, '/ queryStrings : ', queryStrings);
    if (authRequired) {
        if ( StringUtil.nvl(queryStrings['r'], '').indexOf('basis/common/mail/viewer') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => Mail', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/mail/viewer`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('basis/common/mail/knowledgeViewer') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => Knowledge Viewer', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/mail/knowledgeViewer`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('gspnlogin') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => GSPN', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/gspnLogin`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('supportLogin') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => GSPN Support', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/supportLogin`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('gspnERPLogin') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => GSPN ERP', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/gspnERPLogin`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('mgspnLogin') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => MGSPN', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/mgspnLogin`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('msupportLogin') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => MGSPN Support', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/msupportLogin`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('basis/common/gspnCon/commonConnectNew') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => GSPN Common Connection New', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/gspnCon/commonConnectNew`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('basis/common/gspnCon/commonConnect') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => GSPN Common Connection', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/gspnCon/commonConnect`, query: queryStrings });

        }else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('basis/common/gspnCon/commonConnectParts') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => GSPN Common Connection Parts', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/gspnCon/commonConnectParts`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('basis/common/gspnCon/newQuestionConnect') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => GSPN Common Connection New Question', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/gspnCon/newQuestionConnect`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('basis/common/gspnCon/commonConnectBulletin') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => GSPN Common Connection knowledge detail', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/gspnCon/commonConnectBulletin`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('scmslogin') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => SCMS', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/scmsLogin`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('scmsKnowledgeLogin') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => SCMS', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/scmsKnowledgeLogin`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('scmsSupportLogin') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => SCMS Support', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/scmsSupportLogin`, query: queryStrings });
        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('registerAccessCSP') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect User Register page =>', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/registerAccessCSP`, query: queryStrings });
        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('registerAccess') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect User Register page =>', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/registerAccess`, query: queryStrings });
        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('requestForAuthCSP') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect Resiter => Others', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/requestForAuthCSP`, query: queryStrings });
        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('requestForAuth') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect Resiter => Others', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/requestForAuth`, query: queryStrings });

        } else if ( StringUtil.nvl(queryStrings['r'], '').indexOf('basis/common/mail/serviceBulletinViewer') > -1 ) {
            localStorage.clear();
            Vue.$log.info('※ 1.1) detect other system login => Knowledge Viewer', '/ queryString:', queryStrings);
            return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/basis/common/mail/serviceBulletinViewer`, query: queryStrings });

        }

        if (!loggedIn) {
            if (to.fullPath.indexOf(`${SDLUtil.WEB_CONTEXT_PATH}/404`) > -1 || to.fullPath === `${SDLUtil.WEB_CONTEXT_PATH}/`) {
                store.commit('PARAMS', {});
                return next(`${SDLUtil.WEB_CONTEXT_PATH}/no_auth`);
            }

            // local 환경에서만 로그인 페이지로 이동
            if(SDLUtil.isLocal()) {
                return next({ path: `${SDLUtil.WEB_CONTEXT_PATH}/Sensp560`, query: { r: to.fullPath } });

            } else {
                store.commit('PARAMS', {});
                return next(`${SDLUtil.WEB_CONTEXT_PATH}/no_auth`);
            }
        }
    }

    let userPreferLang;
    const userInfo = SDLUtil.getLoginedUserInfo();
    if (userInfo && userInfo.locale) { userPreferLang = userInfo.locale; }

    // TODO : last access time & token expire time check
    const lastAccessTimeNumber = !StringUtil.isNull(localStorage.getItem('lastAccessTime')) ? Number(localStorage.getItem('lastAccessTime')) : 0;
    if(loggedIn && (!isNaN(lastAccessTimeNumber) || lastAccessTimeNumber !== 0)) {
        const lastAccessTime = moment(lastAccessTimeNumber);
        const parseToken = SDLUtil.parseJwt(store.getters.getToken);
        const exp = moment(parseToken['exp'] * 1000);
        Vue.$log.info("※ 2) Token expire date : ", exp.format('YYYY-MM-DD HH:mm:ss'), "/ Last Access Time : ", lastAccessTime.format('YYYY-MM-DD HH:mm:ss'));
        if(exp.diff(moment()) < 0) {
            // token expired event
            const isRefresh = /*(exp.diff(lastAccessTime) < 0)*/ true ? true : false;
            Vue.$log.warn('※ 2.1) Access Token expired. ' + (isRefresh ? "Try refresh token." : ''));
            //if(isRefresh) api.refreshToken();
        }
    }

    const lang = (userPreferLang || window.navigator.userLanguage || window.navigator.language || 'en-US')
        .replace('-', '_')
        .split('_')[0];

    Vue.$log.info('※ 3) router.beforeEach loadLanguageAsync next() ', userPreferLang, lang);

    loadLanguageAsync(lang).then(() => {
        if (store.getters.getLocale !== '') {
            i18n.locale = store.getters.getLocale;
        }

        Vue.$log.info("※ 4.1) Language ['"+ lang +"'] load complete. isLogin => ", SDLUtil.isLogin());
        if (SDLUtil.isLogin() && store.getters.getMenus.length === 0) {
            Vue.$log.info('※ 4.1.1) router.beforeEach i18n.locale next() ', store.getters.getLocale, store.getters.getMenus);
            store.dispatch('getMenus', true);
        }

        return next();
    });
});

router.onError(error => {
    Vue.$log.error('※ Router error => ', error);
    if (/loading chunk \d* failed./i.test(error.message)) {
        window.location.reload();
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js